import { defineMessages } from 'react-intl';

const _default_1: {
	noDateSet: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	fiscalYearPrefix: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	noDateSet: {
		id: 'date-range-picker.date-range.no-date-set',
		defaultMessage: 'No date set',
		description: 'Message to show when no date is set',
	},
	fiscalYearPrefix: {
		id: 'date-range-picker.date-range.fiscal-year-prefix',
		defaultMessage: 'FY',
		description: 'Fiscal year prefix used in interval labels (e.g. "Q1 FY26")',
	},
});
export default _default_1;
